import { render, staticRenderFns } from "./WellnessOverviewChart.vue?vue&type=template&id=364d07dc&scoped=true"
import script from "./WellnessOverviewChart.vue?vue&type=script&lang=js"
export * from "./WellnessOverviewChart.vue?vue&type=script&lang=js"
import style0 from "./WellnessOverviewChart.vue?vue&type=style&index=0&id=364d07dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364d07dc",
  null
  
)

export default component.exports